import { BaseRouteService } from "./BaseRouteService";

export class InventoryService extends BaseRouteService {
    public async getInventory(): Promise<string[]> {
        const response: { inventory: string[] } = await this.getJsonApi<{ inventory: string[] }>("game/inventory");
        return response.inventory;
    }

    public async getToggleInventory(): Promise<boolean> {
        const response: { toggleInventory: boolean } = await this.getJsonApi<{ toggleInventory: boolean }>("game/inventory/toggle");
        return response.toggleInventory;
    }
}
